export const hungarianLabels = {
  layers: "Rétegek",
  layersSearch: "Réteg keresése",
  layersMenu: "További műveletek",
  allOn: "Mind be",
  allOff: "Mind ki",
  reset: "Alapállapot",
  baseMaps: "Alaptérkép",
  objects: "Objektumok",
  otherLayers: "Egyéb",
  legend: "Jelmagyarázat",
  grouping: "Csoportosítás",
  groupingWarning: "Csoportosítás nélkül több mint 2000 objektum rajzolódik, a térkép lassulhat.",
  opacity: "Átlátszóság",
  zoomTo: "Ráközelítés",
  onlyThis: "Csak ezt",
  zoomRange: "{min} – {max}",
  zoomToSee: "nagyíts a megjelenítéshez",
  groupsSuffix: "csoport",
  loading: "Betöltés",
  loadFailed: "A réteg betöltése nem sikerült",
  noLayers: "Nincs elérhető réteg",
  noResults: "Nincs találat",
  hostDrawsLayers: "Ez a térkép maga rajzolja a rétegeit",
  objectsSuffix: "objektum",
  selectedCount: "{count} kijelölve",
  clearSelection: "Kijelölés törlése",
  close: "Bezárás",
  copy: "Másolás",
  copied: "Másolva",
  coordinates: "Koordináták",
  address: "Cím",
  layer: "Réteg",
  picture: "Kép",
  noPicture: "Nincs kép",
  objectNotFound: "Az objektum nem található",
  members: "{count} objektum ezen a helyen",
  featureTitle: "Térképelem",
  featureChooser: "Több elem is van ezen a ponton",
  featureSave: "Mentés",
  featureSaved: "Mentve",
  featureSaveFailed: "A mentés nem sikerült",
  featureNoFields: "Ehhez az elemhez nem tartozik adat",
  featureLoadFailed: "Az elem betöltése nem sikerült",
  photos: "Képek",
  addPhoto: "Kép hozzáadása",
  removePhoto: "Kép törlése",
  uploadFailed: "A feltöltés nem sikerült",
  photoOf: "Kép {index}/{count}",
  previous: "Előző",
  next: "Következő",
  routeTo: "Útvonal ide",
  routeFailed: "Nem található útvonal",
  locationUnavailable: "A saját helyzet nem érhető el",
  yes: "igen",
  no: "nem",
  drawPoint: "Pont",
  drawLine: "Vonal",
  drawPolygon: "Terület",
  drawFinish: "Kész",
  drawCancel: "Mégse",
  drawUndo: "Visszavonás",
  drawRedo: "Újra",
  drawSnap: "Illesztés",
  drawSnapOff: "Illesztés ki",
  drawReverse: "Irány",
  drawSimplify: "Egyszerűsítés",
  drawSimplifyTolerance: "Tűrés",
  drawMerge: "Összevonás",
  drawDelete: "Törlés",
  drawVertexCount: "{count} pont",
  drawSegment: "Szakasz",
  drawTotal: "Hossz",
  drawArea: "Terület",
  drawPerimeter: "Kerület",
  drawNeedsTwo: "A vonalhoz legalább két pont kell",
  drawNeedsThree: "A területhez legalább három pont kell",
  drawSelfIntersects: "A terület határa metszi önmagát",
  drawHintPoint: "Kattintson a térképre a pont elhelyezéséhez, a jelölő húzható.",
  drawHintLine: "Kattintással vegyen fel pontokat, dupla kattintás vagy Enter zár, Esc megszakít.",
  drawHintPolygon: "Kattintással vegyen fel sarokpontokat, dupla kattintás vagy Enter zár, Esc megszakít.",
  drawHintEdit: "A pontok húzhatók, a felezőpont új pontot szúr be, jobb kattintás töröl. Alt+húzás mozgat, Ctrl+kattintás vág.",
  hintOk: "Rendben",
  vertexTooltip: "{index}. pont",
  midpointTooltip: "Húzza el új pont beszúrásához",
  measure: "Mérés",
  measureDistance: "Távolság",
  measureArea: "Terület",
  measureClear: "Törlés",
  measureHint: "Kattintással mérjen, dupla kattintás zár.",
  locate: "Saját helyzet",
  locateFailed: "A helymeghatározás nem sikerült",
  locateAccuracy: "Pontosság: {meters} m",
  fullscreen: "Teljes képernyő",
  exitFullscreen: "Kilépés a teljes képernyőből",
  fitView: "Teljes nézet",
  miniMap: "Áttekintő térkép",
  zoomIn: "Nagyítás (+)",
  zoomOut: "Kicsinyítés (-)",
  searchPlaceholder: "Keresés",
  searchAddress: "Cím",
  searchNoResults: "Nincs találat",
  searchFailed: "A keresés nem sikerült",
  searchMinimum: "Legalább négy karakter",
  resultsTab: "Találatok",
  resultsEmpty: "Keress a fenti mezőben, vagy kattints a térképre",
  resultsFor: "Találatok: {term}",
  resultsCapped: "{layer}: csak az első {count} találat látható, pontosítsd a keresést.",
  layerFeatures: "Rétegelemek",
  coordinatesWgs: "WGS84",
  coordinatesEov: "EOV",
  coordinatesApproximate: "közelítő, kb. 1 m",
  coordinatesSwitch: "Váltás WGS84 és EOV között",
  scale: "Méretarány",
  trackPlay: "Lejátszás",
  trackPause: "Szünet",
  trackSpeed: "Sebesség",
  errorUnauthorized: "Bejelentkezés szükséges",
  errorForbidden: "Nincs jogosultság",
  errorNotFound: "Nem található",
  errorNetwork: "A kiszolgáló nem érhető el",
  errorGeneric: "A kérés meghiúsult",
  serverErrorInvalidCredentials: "Hibás e-mail cím vagy jelszó",
  serverErrorEmailNotConfirmed: "Az e-mail cím még nincs megerősítve, kérjük, kattintson a megerősítő levélben kapott hivatkozásra",
  serverErrorInvalidEmail: "Az e-mail cím formátuma hibás",
  serverErrorDuplicateEmail: "Ezzel az e-mail címmel már van felhasználó",
  serverErrorPasswordsDoNotMatch: "A két jelszó nem egyezik",
  serverErrorInvalidCurrentPassword: "A jelenlegi jelszó hibás",
  serverErrorPasswordTooShort: "A jelszó legalább 6 karakter legyen",
  serverErrorPasswordRequiresDigit: "A jelszóban legyen legalább egy számjegy",
  serverErrorPasswordRequiresLower: "A jelszóban legyen legalább egy kisbetű",
  serverErrorPasswordRequiresUpper: "A jelszóban legyen legalább egy nagybetű",
  serverErrorPasswordRequiresNonAlphanumeric: "A jelszóban legyen legalább egy írásjel vagy más szimbólum",
  serverErrorPasswordRequiresUniqueChars: "A jelszóban több különböző karakter legyen",
  serverErrorInvalidToken: "A hivatkozás érvénytelen vagy lejárt",
  serverErrorNameRequired: "A név kötelező",
  serverErrorNameTooLong: "A név legfeljebb 200 karakter lehet",
  serverErrorNotApiKeyUser: "Ez a felhasználó nem API kulcsos felhasználó",
  serverErrorInvalidGraceMinutes: "A régi kulcs érvényessége 0 és 10080 perc között lehet",
  serverErrorApiKeyUserHasNoPassword: "API kulcsos felhasználónak nem lehet jelszava",
  maps: "Térképek",
  mapsSection: "Térképek",
  layersSection: "Rétegek",
  othersSection: "Egyéb",
  group: "Csoport",
  singleSelect: "Egy választható",
  allLeaves: "Minden réteg bekapcsolva",
  someLeaves: "Néhány réteg bekapcsolva",
  truncatedHint: "A réteg csak az elemek egy részét mutatja, nagyítson a többihez",
  signIn: "Bejelentkezés",
  signOut: "Kijelentkezés",
  email: "E-mail",
  password: "Jelszó",
  staySignedIn: "Maradjak bejelentkezve",
  loginFailed: "A bejelentkezés nem sikerült",
  admin: "Adminisztráció",
  adminMaps: "Térképek kezelése",
  adminLayers: "Rétegek kezelése",
  adminUsers: "Felhasználók kezelése",
  adminRoles: "Szerepkörök kezelése",
  account: "Fiók",
  changePassword: "Jelszó módosítása",
  save: "Mentés",
  saving: "Mentés folyamatban",
  saved: "Mentve",
  saveFailed: "A mentés nem sikerült",
  cancel: "Mégse",
  delete: "Törlés",
  confirmDelete: "Biztosan törli?",
  duplicate: "Másolat",
  newGroup: "Új csoport",
  newLeaf: "Új réteg",
  kind: "Típus",
  settings: "Beállítások",
  idName: "Azonosító",
  name: "Név",
  order: "Sorrend",
  visible: "Látható",
  hidden: "Rejtett",
  problems: "Problémák",
  noProblems: "Nincs probléma",
  validating: "Ellenőrzés",
  folder: "Mappa",
  sldLayer: "SLD réteg",
  urlTemplate: "URL minta",
  provider: "Szolgáltató",
  dark: "Sötét",
  previewTile: "Előnézeti csempe",
  moveUp: "Feljebb",
  moveDown: "Lejjebb",
  dragToMove: "Húzza az áthelyezéshez",
  users: "Felhasználók",
  roles: "Szerepkörök",
  active: "Aktív",
  inactive: "Inaktív",
  createUser: "Új felhasználó",
  editUser: "Felhasználó szerkesztése",
  resetPassword: "Jelszó visszaállítása",
  fullName: "Teljes név",
  phoneNumber: "Telefonszám",
  role: "Szerepkör",
  featureAccess: "Funkció hozzáférés",
  none: "Nincs",
  readOnly: "Csak olvasás",
  full: "Teljes",
  loadingCatalogue: "A térképkatalógus betöltése",
  catalogueFailed: "A térképkatalógus betöltése nem sikerült",
  retry: "Újra",
  offline: "Nincs kapcsolat",
  embedBlocked: "A beágyazás nem engedélyezett",
  share: "Megosztás",
  copyLink: "Hivatkozás másolása",
  back: "Vissza",
  forward: "Előre",
  info: "Infó",
  search: "Keresés",
  unsavedChanges: "Nem mentett módosítások",
  theme: "Téma",
  selectedLayers: "{count} réteg bekapcsolva",
  truncated: "A réteg nem minden eleme látható, nagyítson",
  dismiss: "Elvetés",
  more: "Továbbiak",
  openPanel: "Panel megnyitása",
  closePanel: "Panel bezárása",
  pinPanel: "Panel rögzítése",
  unpinPanel: "Rögzítés feloldása",
  cursorPosition: "Kurzor",
  mapCentre: "Középpont",
  copyMachine: "Másolás gépi formában",
  noSelection: "Nincs kijelölés",
  legendEmpty: "Nincs jelmagyarázat",
  tabLayers: "Rétegek",
  tabInfo: "Információ",
  pinned: "Rögzítve",
  unpin: "Rögzítés feloldása",
  pin: "Rögzítés",
  themeLight: "Világos",
  themeDark: "Sötét",
  themeSystem: "Rendszer",
  language: "Nyelv",
  compactView: "Tömör nézet",
  collapseAll: "Mind összecsuk",
  expandAll: "Mind kinyit",
  breadcrumbSeparator: " › ",
  countFormat: "{count}",
  zoomRangeShort: "z{min}-{max}",
  panelTitle: "Térképek és rétegek",
  selectedObject: "Kijelölt elem",
  openInWindow: "Megnyitás ablakban",
  backToPanel: "Vissza az oldalsávba",
  layerTable: "Adatok táblázatban",
  tableRows: "{count} sor",
  zoomToRow: "Ráközelítés",
  refresh: "Frissítés",
  exportCsv: "Exportálás (CSV)",
  changedFrom: "Változás -tól",
  changedTo: "Változás -ig",
  apply: "Alkalmaz",
  mapsRoot: "Térképek",
  layersRoot: "Rétegek",
  on: "be",
  filterLayers: "Szűrés névre",
  menu: "Menü",
  noTable: "Ennek a rétegnek nincs adattáblája",
  zoomLevel: "Nagyítási szint",
  clusterTitle: "{count} objektum"
};
